<template>
  <Modal v-model="IsOpenModal" :closable="false" :mask-closable="false" :width="60" :footer-hide="true"
    :title="operationType==1?'添加新转发':'修改解析规则'">
    <div class="formGroup">
      <div>
        <Form ref="DNSformItem" :model="DNSformItem" :rules="ruleValidate">
          <FormItem>
            <Row>
              <Col span="4">
              <h3>来源IP段：</h3>
              </Col>
              <Col span="20">
              <Row>
                <Col span="8">
                <Input v-model="DNSformItem.ipFrom" style="width:200px" placeholder="开始地址，包含"></Input>
                </Col>
                <Col span="2" style="text-align: center">至</Col>
                <Col span="10">
                <Input v-model="DNSformItem.ipTo" style="width:200px" placeholder="结束地址，包含"></Input>
                </Col>
              </Row>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="4">
              <h3>请求时间段：</h3>
              </Col>
              <Col span="20">
              <Row>
                <Col span="8">
                <TimePicker type="time" v-model="DNSformItem.timeFrom" placeholder="开始时间" style="width: 200px">
                </TimePicker>
                </Col>
                <Col span="2" style="text-align: center">至</Col>
                <Col span="10">
                <TimePicker type="time" v-model="DNSformItem.timeTo" placeholder="结束时间" style="width: 200px">
                </TimePicker>
                </Col>
              </Row>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="4">
              <h3>匹配模式：</h3>
              </Col>
              <Col span="20">
              <FormItem prop="matchMode">
                <RadioGroup v-model="DNSformItem.matchMode">
                  <Radio label="prefix">前缀匹配，如www.匹配www.sina.com.cn、www.163.com等</Radio><br>
                  <Radio label="suffix">后缀匹配，如.baidu.com匹配www.baidu.com、tieba.baidu.com等</Radio><br>
                  <Radio label="equals">完全匹配，必须与查询的域名一致</Radio><br>
                  <Radio label="contains">包含，只要解析的域名中包含指定的域名即可</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="4">
              <h3>匹配域名：</h3>
              </Col>
              <Col span="20">
              <FormItem prop="name">
                <Input v-model="DNSformItem.name" style="width:400px" placeholder="如：baidu.com"></Input>
              </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="4">
              <h3>应答IP分发模式：</h3>
              </Col>
              <Col span="20">
              <FormItem prop="dispatchMode">
                <RadioGroup v-model="DNSformItem.dispatchMode">
                  <Radio label="round-robin">轮循，依次应答</Radio><br>
                  <Radio label="iphash">IP Hash，与请求来源IP绑定</Radio><br>
                  <Radio label="random">随机</Radio>
                </RadioGroup>
              </FormItem>
              </Col>
            </Row>
          </FormItem>
        </Form>
      </div>
      <div>
        <Input v-model="DNSformItem.addresses" type="textarea" :autosize="{minRows: 5,maxRows: 15}"
          placeholder="请输入应答IP，一行一个地址"></Input>
      </div>
    </div>
    <!-- 按钮组 -->
    <div class="btnGroup">
      <Button class="ys-cancel" @click="handleClick(1)">取消</Button>&nbsp;&nbsp;
      <Button class="ys-confirm" @click="handleClick(2)">确定</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    props: {
      // 是否打开弹框
      IsOpenModal: {
        type: Boolean,
        default: false
      },
      // 操作状态 1 新增  2 编辑
      operationType: {
        type: Number,
        default: 1
      },
      // 编辑信息
      EditDNSInfo: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        DNSformItem: {
          ipFrom: '', // IP 开始地址
          ipTo: '', // IP 结束地址
          timeFrom: '', // 请求时段 开始时间
          timeTo: '', // 请求时段  结束时间
          matchMode: 'equals', // 匹配模式
          name: '', // 匹配域名
          dispatchMode: 'round-robin', // 应答IP分发模式
          addresses: '', // 应答IP
        },
        ruleValidate: {
          name: [{
            required: true,
            message: '请输入匹配域名',
            trigger: 'blur'
          }],
          matchMode: [{
            required: true,
            message: '请选择匹配模式',
            trigger: 'change'
          }],
          dispatchMode: [{
            required: true,
            message: '请选择应答IP分发模式',
            trigger: 'change'
          }]
        }
      }
    },
    mounted() {
      console.log(this.EditDNSInfo, "***********************************");
    },
    methods: {
      handleClick(index) {
        // 1 取消   2 保存
        if (index === 1) {
          this.$emit("on-handleClick", index);
        } else {
          this.$refs['DNSformItem'].validate((valid) => {
            if (valid) {
              this.$emit("on-handleClick", index, this.DNSformItem);
            } else {
              this.$Message.error('请完善信息!');
            }
          })
        }
      }
    },
    watch: {
      operationType(newVal) {
        if (newVal == 1) {
          this.$refs["DNSformItem"].resetFields();
          this.DNSformItem = {
            ipFrom: '', // IP 开始地址
            ipTo: '', // IP 结束地址
            timeFrom: '', // 请求时段 开始时间
            timeTo: '', // 请求时段  结束时间
            matchMode: 'equals', // 匹配模式
            name: '', // 匹配域名
            dispatchMode: 'round-robin', // 应答IP分发模式
            addresses: '', // 应答IP
          }
        } else {
          this.DNSformItem = this.EditDNSInfo;
          this.DNSformItem.ipFrom = this.EditDNSInfo.fromIP;
          this.DNSformItem.ipTo = this.EditDNSInfo.toIP;
        }
      },
      EditDNSInfo(newVal) {
        this.DNSformItem = newVal;
        this.DNSformItem.ipFrom = newVal.fromIP;
        this.DNSformItem.ipTo = newVal.toIP;
      }
    }
  }
</script>
<style lang="less" scoped>
  .formGroup {
    padding: 10px 20px;
    display: flex;

    &>div:first-child {
      width: 70%;
      padding-right: 20px;
    }

    &>div:last-child {
      width: 30%;
    }
  }

  .btnGroup {
    height: 50px;
    width: 100%;
    padding-right: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
</style>